import * as React from 'react';
import * as style from './Builder.css';

import { INewbuildingBuilderSchema } from '../../../../repositories/newbuilding-card/entities/builder/NewbuildingBuilderSchema';
import { BuilderLogo } from '../../../BuilderLogo';
import { trackTransferToDeveloperCard } from '../../../../analytics/trackTransferToDeveloperCard';
import { Link } from '../../../Link';
import { ArticleHeading2, InlineText2 } from '@cian/ui-kit';
import { InfoItem } from '../InfoItem';

export interface IBuilderProps {
  builder: INewbuildingBuilderSchema;
}

export const Builder = (props: IBuilderProps) => {
  const { name, logoUrl, yearOfFoundation, stats, description, profileUrl } = props.builder;

  return (
    <div className={style['builder']}>
      <div className={style['builder-card']}>
        <BuilderLogo
          customStyles={style['builder-logo']}
          src={logoUrl}
          name={name}
          website={profileUrl}
          onClick={() => trackTransferToDeveloperCard(profileUrl)}
        />
        <ArticleHeading2>{`Застройщик ${name}`}</ArticleHeading2>
        <div className={style['builder-stats']}>
          {yearOfFoundation && <InfoItem url={''} text={`в ${yearOfFoundation} году`} label={'Год основания'} />}
          {stats?.done && <InfoItem url={stats.done.qs} text={stats.done.text} label={'Сдано'} />}
          {stats?.inProgress && (
            <InfoItem url={stats.inProgress?.qs} text={stats.inProgress?.text} label={'Строится'} />
          )}
        </div>
        {description && (
          <div className={style['builder-description']}>
            <InlineText2 color={'gray60_100'}>{description}</InlineText2>
            <Link
              target="blank"
              linkStyle={style['description-moreButton']}
              url={profileUrl}
              onClick={() => trackTransferToDeveloperCard(profileUrl)}
            >
              Подробное описание
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};
